module.exports = __webpack_public_path__ + "img/litcom_box.48838c91.png";